import { ConnectButton } from '@rainbow-me/rainbowkit';

import ChevronIcon from '@/app/assets/svg/arrow-right.svg?react';
import { Logo } from '@/app/components/Header/common/Logo';
import { NavMenu } from '@/app/components/Header/common/NavMenu';
import { TvlInfo } from '@/app/components/Header/common/TvlInfo';
import { MobileHeader } from '@/app/components/Header/layouts/MobileHeader';
import { ThemeToggle } from '@/app/components/ThemeToggle/ThemeToggle';
import { isServiceMode } from '@/app/shared/constants/env';
import { cn } from '@/app/shared/lib/cn';
import { Button } from '@/app/shared/ui/Button';

export const DesktopHeader = ({ tvl, isLoading }: MobileHeader) => {
  return (
    <div className='border-decoration-stroke flex items-stretch border-b max-xl:hidden'>
      <div className='bg-decoration-stroke border-decoration-stroke w-6 border-r' />

      <div className='flex flex-1 items-center justify-between px-5 py-4'>
        <div className='flex items-center justify-between gap-8'>
          <Logo />
          <NavMenu />
        </div>
        <div className='flex items-center gap-3'>
          <TvlInfo tvl={tvl} isLoading={isLoading} />
          <div className='w-20'>
            <ThemeToggle />
          </div>
          <div className={cn('w-40', isServiceMode && 'pointer-events-none')}>
            <ConnectButton.Custom>
              {({ account, chain, openAccountModal, openConnectModal, authenticationStatus, mounted }) => {
                const ready = mounted && authenticationStatus !== 'loading';
                const connected =
                  ready && account && chain && (!authenticationStatus || authenticationStatus === 'authenticated');

                if (!ready) {
                  return <div className='h-10 w-full animate-pulse rounded bg-gray-800/50' />;
                }

                return (
                  <div>
                    {(() => {
                      if (!connected) {
                        return (
                          <Button
                            onClick={openConnectModal}
                            variant='outline'
                            className='h-10 w-full whitespace-nowrap transition-none'
                          >
                            Connect Wallet
                          </Button>
                        );
                      }

                      return (
                        <Button
                          onClick={openAccountModal}
                          variant='ghost'
                          className='bg-gray-800 text-foreground flex h-10 w-full justify-between font-medium transition-none'
                        >
                          {account.displayName}
                          <ChevronIcon className='rotate-90' />
                        </Button>
                      );
                    })()}
                  </div>
                );
              }}
            </ConnectButton.Custom>
          </div>
        </div>
      </div>

      <div className='bg-decoration-stroke border-decoration-stroke w-6 border-l'></div>
    </div>
  );
};
